export default "__VITE_ASSET__Ao2_wCIO__"